<template>
  <layout-main-inner v-loading="loading">
    <div slot="action">
      <el-button
        type="primary"
        @click="additem">新增证书</el-button>
    </div>
    <layout-card-wrap hasSlot>
      <template slot="form">
        <el-input
          v-model="config.certName"
          clearable
          placeholder="请输入证书名称"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="证书名称"
          fixed="left"
          min-width="140"
          prop="certName"> </el-table-column>
        <el-table-column
          label="机构名称"
          min-width="140"
          prop="regulatorName"> </el-table-column>
        <el-table-column
          label="所属企业"
          min-width="160"
          prop="vendorName"> </el-table-column>
        <el-table-column
          label="证书图片"
          min-width="300px">
          <template slot-scope="{row}">
            <image-list
              :list="row.certFile"
              style="--image-width:48px;--image-height: 48px" />
          </template>
        </el-table-column>
        <el-table-column
          label="有效期"
          min-width="180">
          <template slot-scope="{row}">{{ row.certBeginTime | dateformat('YYYY-MM-DD') }} ~ {{ row.certEndTime | dateformat('YYYY-MM-DD') }}</template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="110">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="updateitem(row)">编辑</el-button>
            <el-dropdown>
              <el-button
                type="text"
                style="margin-left: 10px;">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="updateitemfile(row)">管理证书文件</el-dropdown-item>
                <el-dropdown-item @click.native="deleteitem(row)">删除证书</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <pagination-new
        v-model="config"
        :total="total"
        :fetch="fetchList" />
    </layout-card-wrap>
    <certificate-modal
      ref="modal"
      @fetch="fetchList" />
  </layout-main-inner>
</template>
<script>
import ImageList from '../../../components/image-list.vue'
import CertificateModal from './certificate-modal.vue'
import Commom from '@/service/common'
export default {
  name: 'VendorCertificateList',
  components: { CertificateModal, ImageList },
  props: {
    certLevel: { type: Number, default: 1 }
  },
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      config: { pageNum: 1, pageSize: 10, certName: '', vendorName: '', vendorId: null }
    }
  },
  mounted() {
    this.config = { ...this.config, ...this.$route.query }
    this.fetchList()
  },
  methods: {
    additem() {
      const { vendorId, vendorName } = this.config
      this.$refs.modal.init({ vendorId, vendorName, certLevel: this.certLevel })
    },
    updateitem(row) {
      const { vendorId, vendorName, certId, certName, regulatorName, certLevel } = row
      this.$refs.modal.init({ vendorId, vendorName, certId, certName, regulatorName, certLevel })
    },
    updateitemfile(row) {
      const { vendorName, vendorId, certName, certId } = row
      const path = this.certLevel === 1 ? '/certificate-file' : '/product-certificate-file'
      this.$router.push({ path, query: { vendorName, vendorId, certName, certId }})
    },
    deleteitem(row) {
      this.$confirm('您确定删除该证书?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          Commom.deletecertificate({ vendorId: row.vendorId, certId: row.certId })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.loading = false
                this.$message.success('删除成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      Commom.getcertificates({ ...this.config, certLevel: this.certLevel })
        .then(res => {
          this.loading = false
          const { result, message, records, total } = res.data
          if ([0, 13].includes(result)) {
            this.loading = false
            this.total = total
            this.list = records.map(i => ({ ...i, certFile: this.$splitImage(i.certFile) }))
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
